export class DraftSpecial {
  constructor(public special: string, public schema: string) {
  }

  static clone(special: DraftSpecial): DraftSpecial {
    return JSON.parse(JSON.stringify(special)) as DraftSpecial;
  }
}
